import { Pipe, type PipeTransform } from '@angular/core';

import { CellType } from '../../cells.interfaces';

@Pipe({
  name: 'shouldStopEvent',
})
export class ShouldStopEventPipe implements PipeTransform {
  public transform(cellType: CellType): boolean {
    return [CellType.ActionsDropdown, CellType.Button, CellType.Form].includes(
      cellType,
    );
  }
}
